/*
 * Layout for generating intent examples from a custom utterance. Layout has
 * regions for the locale dropdown, example editor, strength gauge and generated example list.
 */

define([
  "marionette",
  "configuration/properties",
  "modules/topicsSplit/topic/topicExampleGeneratorModal/template/topicExampleGeneratorModalTemplate.html",
], function (Marionette, Properties, TopicExampleGeneratorModalTemplate) {
  let TopicExampleGeneratorModalView = {};

  TopicExampleGeneratorModalView.topicExampleGeneratorModalLayout = Marionette.Layout.extend({
    template: TopicExampleGeneratorModalTemplate,
    modelEvents: {
      sync: "render",
    },
    disableButtons: function () {
      this.$el.find("#addGeneratedExamplesButton").prop("disabled", true);
      this.$el.find("#regenerateExamplesButton").prop("disabled", true);
    },
    regions: {
      locale: "#locale",
      editor: "#editor",
      gauge: "#gauge",
      generatedExamplesList: "#generatedExamplesList",
    },
    triggers: {
      "click #generateExamplesButton": "generate:examples",
      "click #addGeneratedExamplesButton": "add:generated:examples",
      "click #regenerateExamplesButton": "regenerate:examples",
      "click #cancelButton": "cancel",
    },
  });

  return TopicExampleGeneratorModalView;
});
